module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_prize-one.d493f62d.png";